(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/pages/rejected/rejected.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/pages/rejected/rejected.js');
'use strict';

const Button = svs.ui.ReactButton;
const _svs$playerRegistrati = svs.playerRegistration.components,
  DesktopContentConstrain = _svs$playerRegistrati.DesktopContentConstrain,
  Header = _svs$playerRegistrati.Header,
  PageTitle = _svs$playerRegistrati.PageTitle;
const GridBase = svs.tb_ui_react.gridbase.GridBase;
const Rejected = () => React.createElement(React.Fragment, null, React.createElement(Header, {
  isForceStandardBranding: true
}), React.createElement(DesktopContentConstrain, null, React.createElement(GridBase, null, React.createElement(PageTitle, null, "Hej!"), React.createElement("p", null, "Just nu kan du inte bli kund hos Svenska Spel. N\xE5gra exempel p\xE5 orsaker:"), React.createElement("div", {
  className: "margin-bottom-1 f-content"
}, React.createElement("ul", {
  className: "player-registration-list-group"
}, React.createElement("li", {
  className: "player-registration-list-item"
}, "Du \xE4r under 18 \xE5r."), React.createElement("li", {
  className: "player-registration-list-item"
}, "Du \xE4r inte folkbokf\xF6rd i Sverige."), React.createElement("li", {
  className: "player-registration-list-item"
}, "Du har st\xE4ngt av dig f\xF6r spel hos samtliga licenserade spelbolag i Sverige hos Spelinspektionen.", ' ', "Se", ' ', React.createElement("a", {
  href: "http://www.spelpaus.se?scos=true",
  rel: "noreferrer",
  target: "_blank"
}, "www.spelpaus.se"), "."))), React.createElement("p", {
  className: "margin-bottom-2"
}, "Vid fr\xE5gor, kontakta", ' ', React.createElement("a", {
  href: svs.core.urlMapping.get('customerServiceContact')
}, "Svenska Spels kundservice"), "."), React.createElement("div", {
  className: "align-center"
}, React.createElement(Button, {
  href: svs.core.urlMapping.get('startPage'),
  inverted: true
}, "Till startsidan")))));
svs.playerRegistration.pages.rejected.Rejected = Rejected;

 })(window);